import React, { useCallback } from 'react';
import { Button, ButtonProps } from 'ui-components/common/Button';
import { Link } from 'ui-components/common/Link';
import { useClient } from 'ui-hooks/useClient';
import { DirittoAppBridge } from 'libs/DirittoAppBridge';

export const HomeLinkButton = ({
  className,
  replace,
  ...props
}: ButtonProps & { href?: string; replace?: boolean }) => {
  const client = useClient();
  const handleResetToHome = useCallback(() => DirittoAppBridge.resetToHome(), []);

  if (client.isApp) {
    return <Button onClick={handleResetToHome} {...props} className={className} />;
  }

  return (
    <Link href="/" className={className} replace>
      <Button {...props} />
    </Link>
  );
};
